import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  connect() {
    // Only add listeners if overlay target exists
    if (this.hasOverlayTarget) {
      // Store bound function references so they can be properly removed later
      this.boundShowSpinner = this.showSpinner.bind(this)
      this.boundHideSpinner = this.hideSpinner.bind(this)

      document.addEventListener('turbo:visit', this.boundShowSpinner)
      document.addEventListener('turbo:render', this.boundHideSpinner)
      document.addEventListener('turbo:submit-end', this.boundHideSpinner)
      document.addEventListener('turbo:frame-load', this.boundHideSpinner)
    }
  }

  disconnect() {
    // Only remove listeners if they were added
    if (this.hasOverlayTarget && this.boundShowSpinner && this.boundHideSpinner) {
      document.removeEventListener('turbo:visit', this.boundShowSpinner)
      document.removeEventListener('turbo:render', this.boundHideSpinner)
      document.removeEventListener('turbo:submit-end', this.boundHideSpinner)
      document.removeEventListener('turbo:frame-load', this.boundHideSpinner)

      // Clean up references
      this.boundShowSpinner = null
      this.boundHideSpinner = null
    }
  }

  showSpinner() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove('d-none')
    }
  }

  hideSpinner() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add('d-none')
    }
  }
}
